export default __webpack_public_path__ + "static/inmusic-logo-white-89a8576085ffe8e54d1d4a91cd93dbe1.svg";